import { ResponseStatuses as CommonResponseStatuses } from '../common/enums/ResponseStatuses'

export class ResponseStatuses extends CommonResponseStatuses {}
